import React from 'react';

interface IProps {
  title: string;
}

export const DenominatorTag = (props: IProps) => {
  const { title } = props;
  return <div className={'rounded-[2px] px-[8px] bg-[#E6FAF4] text-[#00A873] text-[12px] leading-[18px]'}>
    {title}
  </div>;
};
